import { render, staticRenderFns } from "./CatalogoFases.vue?vue&type=template&id=00c4a6d4"
import script from "./CatalogoFases.vue?vue&type=script&lang=js"
export * from "./CatalogoFases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports